import type { ReactNode } from 'react'

import { ScrollArea } from '@/components/ui/scroll-area'
import { cn } from '@/lib/utils'

import type { ToolCallContentData } from './tool-call-content.interface'
import { ToolCallHeaderCard } from './tool-call-header-card.atom'
import { ToolCallHtmlReport } from './tool-call-html-report.molecule'
import { ToolCallSection } from './tool-call-section.atom'

interface ToolHtmlReportState {
  html: string | null
  isLoading: boolean
  isError: boolean
}

export interface ToolCallContentProps {
  data: ToolCallContentData
  htmlReport: ToolHtmlReportState
  className?: string
}

export const ToolCallContent: React.FC<ToolCallContentProps> = ({
  data,
  htmlReport,
  className,
}): ReactNode => {
  const { toolCall } = data
  const hasHtmlReport = Boolean(toolCall.htmlResultKey)

  return (
    <ScrollArea className={cn('tool-call-content h-full', className)}>
      <div className="flex flex-col gap-4 p-4">
        <ToolCallHeaderCard toolCall={toolCall} />

        {hasHtmlReport ? (
          <ToolCallHtmlReport
            html={htmlReport.html}
            isLoading={htmlReport.isLoading}
            isError={htmlReport.isError}
          />
        ) : (
          <>
            {toolCall.input && (
              <ToolCallSection title="Input" content={toolCall.input} className="tool-call-input" />
            )}

            {toolCall.output && (
              <ToolCallSection
                title="Output"
                content={toolCall.output}
                className="tool-call-output"
              />
            )}
          </>
        )}

        {toolCall.errorMessage && (
          <ToolCallSection
            title="Error"
            content={toolCall.errorMessage}
            className="tool-call-error"
            isError
          />
        )}
      </div>
    </ScrollArea>
  )
}
